export enum ClaimPages {
  claimNew = 1,
  claimEdit = 2,
  managementNew = 3,
  managementEdit = 4,
  claimAdjustmentEdit = 5,
  dischargeEdit = 6
}
